import { createFileRoute } from "@tanstack/react-router";

import PlanPricingPage from "./-components/PlanPricingPage";

export const Route = createFileRoute("/_app/_dashboard/$planId/pricing")({
  component: PlanPricingPage,
});
